import { useQuery } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';
import { QueryConfig } from '@/lib/react-query';
import { PaginatedResponse, ParamsWithPagination } from '@/types/api';

import { TProgramBroadcast, TProgramBroadcastFilters } from '../types';

import { broadcastScheduleQueryKeys } from './query-keys';

export async function getProgramBroadcasts(
  params?: ParamsWithPagination<TProgramBroadcastFilters>
): Promise<PaginatedResponse<TProgramBroadcast>> {
  return mediaManagerClient.get('/api/v1/program_broadcasts', {
    params: {
      limit: params?.limit,
      offset: params?.offset,
      search: params?.search,
      channel_id: params?.channelId,
      channelMediaType: params?.channelMediaType,
      delivery_datetime_at__in: params?.deliveryDatetimeAtIn?.join(','),
      gte: params?.gte,
      ids: params?.ids?.join(','),
      lte: params?.lte,
      name: params?.name,
      orderBy: params?.orderBy,
      priorities: params?.priorities,
      program_id: params?.programId,
      program_source_id__isnull: params?.programSourceIdIsNull,
      review_states: params?.reviewStates,
      state: params?.state,
    },
  });
}

type QueryFnType = typeof getProgramBroadcasts;

interface UseProgramProadcastsParams {
  config?: QueryConfig<QueryFnType>;
  params?: ParamsWithPagination<TProgramBroadcastFilters>;
}

export function useProgramBroadcasts({ config, params }: UseProgramProadcastsParams = {}) {
  return useQuery({
    ...config,
    queryKey: broadcastScheduleQueryKeys.list(params),
    queryFn: () => getProgramBroadcasts(params),
  });
}
